import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

export default function RegisterPage() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", invite: new URLSearchParams(window.location.search).get("invite") || "" });
  const [err, setErr]   = useState("");
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    const r = await register(form.email, form.password, form.name, form.invite);
    setLoading(false);
    if (r.ok) nav("/", { replace: true });
    else setErr(r.error || "Errore durante la registrazione");
  };

  const inputCls = "w-full px-4 py-3 text-sm bg-slate-50 hover:bg-white focus:bg-white border border-slate-200 focus:border-slate-900 focus:ring-2 focus:ring-slate-900/8 transition-all";

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: '#F0F2F5' }}>
      <div className="w-full max-w-[420px]">
        {/* Logo */}
        <div className="flex items-center gap-3 mb-10">
          <img src="/brand/logo-mark.png" alt="Best Agent" className="w-10 h-10 rounded-[5px] object-cover shrink-0" />
          <div>
            <div className="font-serif text-lg font-light text-slate-900 leading-none">Best Agent</div>
            <div className="text-[9px] uppercase tracking-[0.24em] mt-0.5" style={{ color: 'var(--gold)' }}>Private Wealth CRM</div>
          </div>
        </div>

        <div className="bg-white p-10" style={{ border: '1px solid #E8ECF2', borderRadius: 4, boxShadow: '0 4px 24px rgba(10,25,47,0.07)' }}>
          <div className="text-[10px] uppercase tracking-[0.24em] mb-2" style={{ color: 'var(--gold)' }}>Crea account</div>
          <h1 className="font-serif text-3xl font-light tracking-tight text-slate-900 leading-none mb-2">Registrati.</h1>
          <p className="text-sm text-slate-400 mb-6">Crea il tuo account per accedere alla console.</p>
          <div className="gold-rule mb-8" />

          <form onSubmit={onSubmit} data-testid="register-form">
            {[
              { k: 'name',     label: 'Nome completo', type: 'text',     ph: 'Mario Rossi',         tid: 'register-name' },
              { k: 'invite',   label: 'Codice invito', type: 'text',     ph: 'Codice ricevuto dall\'amministratore', tid: 'register-invite' },
              { k: 'email',    label: 'Email',          type: 'email',    ph: 'nome@dominio.it',     tid: 'register-email' },
              { k: 'password', label: 'Password',       type: 'password', ph: '••••••••',             tid: 'register-password' },
            ].map(({ k, label, type, ph, tid }) => (
              <div key={k} className="mb-5">
                <label className="block text-[11px] font-semibold uppercase tracking-[0.12em] text-slate-500 mb-2">{label}</label>
                <input type={type} value={form[k]} onChange={set(k)} required placeholder={ph}
                  data-testid={tid} className={inputCls} style={{ borderRadius: 2, outline: 'none' }} />
              </div>
            ))}

            {err && (
              <div className="mb-4 text-sm text-rose-700 bg-rose-50 border border-rose-200 px-4 py-3" style={{ borderRadius: 2 }} data-testid="register-error">{err}</div>
            )}

            <button type="submit" disabled={loading} data-testid="register-submit"
              className="w-full text-white font-medium py-3.5 flex items-center justify-center gap-2 transition-all disabled:opacity-60 text-sm"
              style={{ background: 'var(--navy)', borderRadius: 2 }}
              onMouseEnter={e => e.currentTarget.style.background = 'var(--navy-3)'}
              onMouseLeave={e => e.currentTarget.style.background = 'var(--navy)'}>
              {loading && <Loader2 className="w-4 h-4 animate-spin" />}
              Crea account
            </button>
          </form>

          <div className="mt-6 text-xs text-center text-slate-500">
            Hai già un account?{" "}
            <Link to="/login" className="gold-link font-medium" data-testid="link-login">Accedi</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
